// extracted by mini-css-extract-plugin
module.exports = {"media":"PopupPicture_media__msrwJ","content":"PopupPicture_content__0WwzW","video":"PopupPicture_video___jNLz"};